import { Action, PermissionContext, PermissionSet, Resource } from './interfaces';

// Dispatched on `window` whenever setPermissions() runs -- app-root.tsx's initUserPermissions()
// is fire-and-forget relative to route rendering, so a component that gates content on
// hasPermission() at mount time can render before any permissions have loaded at all. Listening
// for this event lets such a component correct itself once the real permission set arrives,
// instead of being stuck with its initial (possibly wrong) guess for the rest of its lifetime.
export const PERMISSIONS_LOADED_EVENT = 'permissions-loaded';

export class PermissionService {
  private static _permissionSet: PermissionSet = {};

  static setPermissions(permissionSet: PermissionSet) {
    this._permissionSet = permissionSet;
    globalThis.dispatchEvent(new CustomEvent(PERMISSIONS_LOADED_EVENT));
  }

  static setPermissionContext(context: PermissionContext) {
    this._permissionContext = context;
  }

  static addPermission(resource: Resource, action: Action) {
    if (this._permissionSet[resource] && !this._permissionSet[resource].includes(action)) {
      this._permissionSet[resource].push(action);
    } else {
      this._permissionSet[resource] = [action];
    }
  }

  static removePermission(resource: Resource, action: Action) {
    if (this._permissionSet[resource]?.includes(action)) {
      const i = this._permissionSet[resource].indexOf(action);
      this._permissionSet[resource].splice(i, 1);
    }
  }

  static hasPermission(resource: Resource | string, action: Action) {
    return !!this._permissionSet[resource]?.includes(action);
  }

  static getPermissionContext = () => PermissionService._permissionContext;
  private static _permissionContext: PermissionContext = { customerId: undefined, appId: undefined };
}
